export default __webpack_public_path__ + "static/media/close.582a71ae.svg";